(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./index.less"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./index.less"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.index);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _index) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        staticClass: "page-layout"
      }, [_c('div', {
        staticClass: "page-layout__main"
      }, [_c('div', {
        staticClass: "page-content",
        style: _vm.getContentStyle
      }, [_vm._t("content")], 2)]), _c('div', {
        staticClass: "page-layout__footer",
        style: _vm.getFooterStyle
      }, [_vm._t("footer")], 2), _vm._t("default")], 2);
    },
    name: 'nx-page-layout',
    props: {
      footerHeight: [String, Number]
    },
    computed: {
      getContentStyle: function getContentStyle() {
        return {
          paddingBottom: this.px2rem(this.footerHeight)
        };
      },
      getFooterStyle: function getFooterStyle() {
        return {
          height: this.px2rem(this.footerHeight),
          marginTop: this.px2rem("-".concat(this.footerHeight))
        };
      }
    },
    methods: {
      px2rem: function px2rem(px) {
        return px / 100 + 'rem';
      }
    }
  };
  _exports.default = _default;
});